import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const bmrCalculatorTool: Tool = {
  id: "bmr-calculator",
  name: () => m.bmr_tool_name(),
  description: () => m.bmr_tool_description(),
  icon: "🔥",
  basePath: "/bmr-calculator",
  status: "stable",
  tags: ["health", "fitness", "calculator", "bmr-calculator"],
};
